/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GeneralResponse } from '../../models/general-response';
import { InputCreateClientDto } from '../../models/input-create-client-dto';

export interface ClientManagementCreateClientPost$Params {
      body?: InputCreateClientDto
}

export function clientManagementCreateClientPost(http: HttpClient, rootUrl: string, params?: ClientManagementCreateClientPost$Params, context?: HttpContext): Observable<StrictHttpResponse<GeneralResponse>> {
  const rb = new RequestBuilder(rootUrl, clientManagementCreateClientPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GeneralResponse>;
    })
  );
}

clientManagementCreateClientPost.PATH = '/ClientManagement/CreateClient';
